"use client";
import { motion } from "framer-motion";
import React from "react";
import "./style.css";

const ThoughtForTheDay = ({
  text = "🌟 Dream big, work hard, stay humble, and let success make the noise. ",
  duration = 7,
  shimmeringColor = "#ffffff",
  baseColor = "#d0e3ff",
  className = "",
}) => {
  return (
    <div
      className={`flex justify-center items-center text-center ${className}`}
      style={{
        position: "fixed", // ensures it's always centered in viewport
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background:
          "linear-gradient(135deg, #0e497b, #19396b, #0e497b, #1a5b8f)",
        backgroundSize: "400% 400%",
        animation: "gradientBG 12s ease infinite",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      {/* Quote text */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.8, ease: "easeOut" }}
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "90%",
          padding: "0 20px",
        }}
      >
        <motion.span
          initial={{ backgroundPosition: "200% center" }}
          animate={{ backgroundPosition: "-200% center" }}
          transition={{
            duration,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{
            backgroundImage: `linear-gradient(
              120deg,
              ${baseColor} 40%,
              ${shimmeringColor} 50%,
              ${baseColor} 60%
            )`,
            backgroundSize: "200% auto",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "inline-block",
            fontSize: "2rem",
            fontWeight: "900",
            fontFamily: "'Playfair Display', serif",
            textShadow: "0 0 25px rgba(255, 255, 255, 0.4)",
            lineHeight: 1.4,
          }}
        >
          {text}
        </motion.span>

        <p
          style={{
            color: "#ffffffcc",
            fontSize: "18px",
            marginTop: "15px",
            letterSpacing: "1px",
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          — Thought for the Day 🌞
        </p>
      </motion.div>
    </div>
  );
};

export default ThoughtForTheDay;
